








































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import { uuid } from "uuidv4";

@Component({
  components: {
    CommonModalHeader,
  },
})
export default class BatchSubmissionModal extends Vue {
  @Prop({ required: true, default: false })
  private isOpenBatchSubmissonModal!: boolean;

  @Emit('close-batch-submission-modal')
  private closeBatchSubmissionModal(){}

  private submitShifts = [
    {
      projectId: 1,
      shiftSubmitterId: 1,
      shiftApplicableId: 1,
      shiftStartTime: 0,
      shiftEndTime: 0,
      bulkSubmissionFlag: true,
      selectedDate: '2000-01-01',
      selectedStartTime: '11:00',
      selectedEndTime: '12:00',
      uuid: uuid(),
    }
  ]

  /**シフト提出メソッド */
  private submit(){
    this.closeBatchSubmissionModal();
  }

  /**シフト追加メソッド */
  private addShift(){
    this.submitShifts.push(
      {
        projectId: 1,
        shiftSubmitterId: 1,
        shiftApplicableId: 1,
        shiftStartTime: 0,
        shiftEndTime: 0,
        bulkSubmissionFlag: true,
        selectedDate: '2000-01-01',
        selectedStartTime: '11:00',
        selectedEndTime: '12:00',
        uuid: uuid(),
      }
    )
  }

  /**シフト削除メソッド */
  private deleteShift(uuid: string){
    if (this.submitShifts.length <= 1) { return }
    const target = this.submitShifts.findIndex((s) => s.uuid === uuid );
    this.submitShifts.splice(target, 1);
  }

  /**バリデーション */
  private validate(){}

  private startTimeChoiceItems() {
    const arr = new Array<string>(96);
    for (let index = 0; index < arr.length; index++) {
      const hour = Math.floor(index / 4);
      const minute = (index % 4) * 15;
      arr[index] = `${`00${hour}`.slice(-2)}:${`00${minute}`.slice(-2)}`
    }
    return arr
  };

  private endTimeChoiceItems() {
    const arr = new Array<string>(96);
    for (let index = 0; index < arr.length; index++) {
      const hour = Math.floor(index / 4);
      const minute = (index % 4) * 15;
      arr[index] = `${`00${hour}`.slice(-2)}:${`00${minute}`.slice(-2)}`
    }
    return arr
  };
}
